import { FC } from 'react';
import { useIntercom } from 'react-use-intercom';

import Button from 'components/_core/Button';
import { logEvent } from 'features/Analytics/analytics';

import locales from './locales';

interface AskQuestionIntercomButtonProps {
  offer: string;
}

const AskQuestionIntercomButton: FC<AskQuestionIntercomButtonProps> = ({
  offer,
}) => {
  const intercom = useIntercom();
  return (
    <Button
      onClick={() => {
        logEvent({
          name: 'InsuranceOfferDetails Intercom Clicked',
          properties: {
            action: 'Ask A Question',
            offer,
          },
          usePrefix: false,
        });

        intercom.hide();
        intercom.showNewMessages(' ');
      }}
      variant="secondary"
      width="100%"
    >
      {locales.text}
    </Button>
  );
};

export default AskQuestionIntercomButton;
